import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from '../../common-class/survey';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-media-control',
  templateUrl: './media-control.component.html',
  styleUrls: ['./media-control.component.css'],
})
export class MediaControlComponent implements OnInit, AfterViewInit {
  @Input() mediaName: string;
  @Input() mediaUrl: string;
  @Input() mediaEmbed: string = '';
  @Input() isLoadFile: boolean;
  @Input() isQuestionMedia: boolean = false;
  @Input() mediaCaption: string;
  @Input() isAnsMedia: boolean = false;
  @ViewChild('embedContainer', { static: false }) embedContainer: ElementRef;
  
  path: string = '';
  productName: string = '';
  MediaAlt: string = '';
  isPlayMedia: boolean;
  isVideoFile: boolean;
  isDownloadFile: boolean;
  isOfflineSurvey: boolean = false;
  idKey: string;

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private offlineSurvey: OfflineSurvey,
    private renderer: Renderer2,
    private el: ElementRef,
    private sanitizer: DomSanitizer
  ) {
    if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
      this.isOfflineSurvey = this.offlineSurvey.isOfflineSurvey;
    }
  }

  ngOnInit() {
    this.idKey = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
    this.path = '../survey/assets';
    this.MediaAlt =
      this.mediaCaption != undefined && this.mediaCaption != '' ? this.mediaCaption : 'graphics';
    this.productName = this.service.getProductName();

    if (this.mediaEmbed == null) {
      if (
        this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'wav' ||
        this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mp3' ||
        this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'wma'
      ) {
        this.isVideoFile = false;

        if (
          this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'wma'
        ) {
          this.isDownloadFile = true;
        } else if (
          /msie\s|trident\//i.test(window.navigator.userAgent) &&
          this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'wav'
        ) {
          this.isDownloadFile = true;
        } else {
          this.isDownloadFile = false;
        }
      } else {
        this.isVideoFile = true;

        if (
          this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mov' ||
          this.mediaName.substring(this.mediaName.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mp4'
        ) {
          this.isDownloadFile = false;
        } else {
          this.isDownloadFile = true;
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.mediaEmbed != null) {
      setTimeout(() => {
        // We need to wait for Angular to render the content before manipulating the DOM
        const embedElement = document.getElementById(`${this.idKey}_embed`);
        if (embedElement) {
          const iframeElement = embedElement.querySelector('iframe');
          
          if (iframeElement && this.hasParentWithClass(iframeElement, 'one-image')) {
            const height = iframeElement.getAttribute('height');
            
            if (!height) {
              this.renderer.setStyle(iframeElement, 'width', '100%');
              const width = iframeElement.clientWidth;
              this.renderer.setStyle(iframeElement, 'height', `${width}px`);
            }
          }
        }
      });
    }
  }

  /**
   * Check if element has a parent with a specific class
   */
  private hasParentWithClass(element: Element, className: string): boolean {
    let current = element.parentElement;
    while (current) {
      if (current.classList.contains(className)) {
        return true;
      }
      current = current.parentElement;
    }
    return false;
  }

  isAnswerMedia(): boolean {
    return this.isAnsMedia;
  }

  playMedia(isPlay: boolean) {
    if (isPlay) {
      this.isPlayMedia = true;
    } else {
      this.isPlayMedia = false;
    }
    this.changeDetect.detectChanges();
  }

  isPlayedFile(url: string): boolean {
    if (
      url.substring(url.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mp3' ||
      url.substring(url.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mov' ||
      url.substring(url.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mp4'
    ) {
      return true;
    } else {
      return false;
    }
  }

  isAudioFile(url: string): boolean {
    if (url.substring(url.lastIndexOf('.') + 1).toLocaleLowerCase() == 'mp3') {
      return true;
    } else {
      return false;
    }
  }

  onFullScreen() {
    const isFullscreenNow = document.fullscreenElement !== null;
    if (!isFullscreenNow) {
      const videoElement = document.getElementById(`${this.idKey}_video`);
      if (videoElement) {
        videoElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
